// Reusable Loading Spinner JavaScript Helper
// Global functions for showing/hiding loading spinners

window.LoadingSpinner = {
  // Show loading spinner in a container
  show: function(containerId, options) {
    options = options || {};
    var locale = options.locale || (typeof I18n !== 'undefined' ? I18n.locale : 'en');
    var message = options.message;
    
    var text = '';
    if (message) {
      text = message;
    } else if (locale === 'ar') {
      text = `<span>جاري</span>
              <span>التحميل</span>`;
    } else {
      text = `<span>L</span>
              <span>o</span>
              <span>a</span>
              <span>d</span>
              <span>i</span>
              <span>n</span>
              <span>g</span>`;
    }
    
    var loaderHtml = `<div class="loader-container">
        <div class="loader"> 
          ${text}
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </div>
    </div>`;
    
    if (typeof $ !== 'undefined') {
      $('#' + containerId).html(loaderHtml);
    } else {
      document.getElementById(containerId).innerHTML = loaderHtml;
    }
  },
  
  // Hide loading spinner and optionally show content
  hide: function(containerId, content) {
    if (content) {
      if (typeof $ !== 'undefined') {
        $('#' + containerId).html(content);
      } else {
        document.getElementById(containerId).innerHTML = content;
      }
    } else {
      if (typeof $ !== 'undefined') {
        $('#' + containerId).empty();
      } else {
        document.getElementById(containerId).innerHTML = '';
      }
    }
  }
};

// Backward compatibility - global function
function showLoader(containerId, options) {
  return LoadingSpinner.show(containerId, options);
}

function hideLoader(containerId, content) {
  return LoadingSpinner.hide(containerId, content);
}